module.exports = __webpack_public_path__ + "img/MED_WHOLE_GRAINS@300x.2def04f3.png";